import { nextTick } from 'vue';
import { useShepherd } from 'vue-shepherd';
import { offset } from '@floating-ui/core';

import base64 from '@js/modules/utils/base64';

export function showTutorial() {
    const tutorial = document.getElementById('tutorial');
    if (tutorial) {
        nextTick(async () => {
            const v = await base64.decode(tutorial.value, 'UTF-8');
            let data = JSON.parse(v);
            startTour(data);
        });
    }
}

export function startTour(data) {
    const tour = useShepherd({
        useModalOverlay: true,
    });
    Object.entries(data).forEach(([key, value]) => {
        let params = {
            id: key,
            title: value.title,
            attachTo: { element: document.querySelector(value.selector), on: value.position },
            text: value.text,
            modalOverlayOpeningPadding: 5,
            modalOverlayOpeningRadius: 5,
            floatingUIOptions: {
                middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
            buttons: [
                {
                    text: value.button_caption,
                    action: tour[value.action],
                    classes: 'btn',
                },
            ],
        };
        const cancel_button = value.show_cancel_button ?? false;
        if (cancel_button) {
            params.buttons.push({
                text: value.cancel_button_caption ?? 'キャンセル',
                action: tour.cancel,
                classes: 'btn shepherd-button-secondary',
            });
        }
        tour.addStep(params);
    });
    tour.start();
}
